module.exports = __webpack_public_path__ + "static/media/iconAbsenceActive.2093ad4f.svg";